import iconNavNoIcon from "../../../assets/icon_nav_noIcon.svg";
import { useState } from "react";
import { Link } from "react-router-dom";

const Badge = ({ badge }) => {
  if (!badge) return null;
  return (
    <div className="absolute -top-2.5 -left-1 inline-flex items-center justify-center flex-1 w-11 h-11 text-center">
      <span className="relative z-10 text-xs font-extrabold text-white">
        {badge.text}
      </span>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 44 44"
        fill="none"
        className="absolute inset-0"
      >
        <path
          d="M24.9025 2.10264C23.3582 0.116152 20.3561 0.116152 18.8117 2.10264C17.9999 3.1469 16.5775 3.4975 15.3733 2.95013C13.0827 1.90888 10.4245 3.30402 9.98019 5.78067C9.74663 7.08259 8.65007 8.05406 7.32949 8.12898C4.81735 8.2715 3.11196 10.7422 3.86952 13.1416C4.26775 14.4029 3.74826 15.7727 2.61376 16.4528C0.4556 17.7464 0.0937371 20.7266 1.87959 22.4992C2.81838 23.431 2.99497 24.8853 2.30645 26.0147C0.996683 28.1631 2.06124 30.9701 4.46628 31.7096C5.73056 32.0984 6.56277 33.3041 6.47796 34.6241C6.31664 37.1351 8.56374 39.1258 11.037 38.663C12.3371 38.4197 13.6343 39.1005 14.1727 40.3088C15.1967 42.6071 18.1116 43.3256 20.0865 41.7664C21.1246 40.9467 22.5896 40.9467 23.6278 41.7664C25.6026 43.3256 28.5175 42.6071 29.5416 40.3088C30.0799 39.1005 31.3771 38.4197 32.6772 38.663C35.1505 39.1258 37.3976 37.1351 37.2363 34.6241C37.1515 33.3041 37.9837 32.0984 39.248 31.7096C41.653 30.9701 42.7175 28.1631 41.4078 26.0147C40.7193 24.8853 40.8958 23.431 41.8346 22.4992C43.6205 20.7266 43.2586 17.7464 41.1005 16.4528C39.966 15.7727 39.4465 14.4029 39.8447 13.1416C40.6023 10.7422 38.8969 8.2715 36.3847 8.12898C35.0642 8.05406 33.9676 7.08259 33.734 5.78067C33.2898 3.30402 30.6315 1.90888 28.3409 2.95013C27.1368 3.4975 25.7144 3.1469 24.9025 2.10264Z"
          fill={badge.color}
          stroke="#FFCF02"
        />
      </svg>
    </div>
  );
};

//아이콘이 없을 경우 처리
function ImageWithFallback({ src, fallbackSrc, alt }) {
  const [imgSrc, setImgSrc] = useState(src);
  const handleError = () => {
    setImgSrc(fallbackSrc);
  };

  return (
    <img src={imgSrc} alt={alt} onError={handleError} className="sm:h-full" />
  );
}

const menuItemClassName =
  "relative block bg-slate-50 rounded-[20px] w-full h-full box-border border-2 flex-1 no-underline text-inherit";

const MenuItemContent = ({ icon, label, badge }) => (
  <div className="absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center">
    <Badge badge={badge} />
    <span className="inline-flex items-center justify-center h-[60%] sm:p-6">
      <ImageWithFallback
        src={icon}
        fallbackSrc={iconNavNoIcon}
        alt={label}
      />
    </span>
    <span className="font-medium text-neutral-950">{label}</span>
  </div>
);

const MenuItem = ({ item: { icon, label, badge }, href, to, onClick }) => {
  const style = {
    paddingTop: "calc(100% -  0.25rem)",
    borderColor: badge?.color || "transparent",
  };

  if (href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        style={style}
        className={menuItemClassName}
      >
        <MenuItemContent icon={icon} label={label} badge={badge} />
      </a>
    );
  }

  if (to) {
    return (
      <Link to={to} onClick={onClick} style={style} className={menuItemClassName}>
        <MenuItemContent icon={icon} label={label} badge={badge} />
      </Link>
    );
  }

  return (
    <div
      style={style}
      className={menuItemClassName}
      onClick={onClick}
      role="button"
    >
      <MenuItemContent icon={icon} label={label} badge={badge} />
    </div>
  );
};

export default MenuItem;
